// Homepage	
export const SET_SHOW_ANNOUNCEMENT = 'SET_SHOW_ANNOUNCEMENT';	
export const SET_HOME_COLLECTION = 'SET_HOME_COLLECTION';	
export const SET_HOME_PRODUCT = 'SET_HOME_PRODUCT';	
export const SET_HOME_COLLECTIONS = 'SET_HOME_COLLECTIONS';	
export const SET_HOME_COLLECTIONS_FAIL = 'SET_HOME_COLLECTIONS_FAIL';	
export const SET_OTHER_COLLECTIONS = 'SET_OTHER_COLLECTIONS';	
export const SET_HOME_LOADING = 'SET_HOME_LOADING';	
export const RESET_HOME_COLLECTIONS = 'RESET_HOME_COLLECTIONS';	
export const GET_VARIANT_ID = 'GET_VARIANT_ID';	
export const SET_DEFAULT_PACKAGE = 'SET_DEFAULT_PACKAGE';	
export const SET_PLUS_PACKAGE = 'SET_PLUS_PACKAGE';	
export const SET_SELECTED_PACKAGE = 'SET_SELECTED_PACKAGE';	

export const TOGGLE_PRICING_AB_TESTING = 'TOGGLE_PRICING_AB_TESTING';	
export const SELECT_PRICING_MODULE = 'SELECT_PRICING_MODULE';

// Login
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const CHANGE_LOGIN_FORM = 'CHANGE_LOGIN_FORM';
export const RETRIEVE_LOCAL_AUTH = 'RETRIEVE_LOCAL_AUTH';
export const CHANGE_REMEMBER = 'CHANGE_REMEMBER';

// Logout
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';


 // Studio	
export const GET_SPACE_META = 'GET_SPACE_META';	
export const GET_BESSIE_LINK = 'GET_BESSIE_LINK';	
export const GET_SPACE_META_SUCCESS = 'GET_SPACE_META_SUCCESS';	
export const GET_SPACE_META_FAIL = 'GET_SPACE_META_FAIL';	
export const GET_SPACE = 'GET_SPACE';	
export const GET_SPACE_SUCCESS = 'GET_SPACE_SUCCESS';	
export const GET_SPACE_FAIL = 'GET_SPACE_FAIL';	
export const TOGGLE_LIGHTBOX = 'TOGGLE_LIGHTBOX';	
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';	
export const TOGGLE_SHARE = 'TOGGLE_SHARE';	
export const TOGGLE_MENU = 'TOGGLE_MENU';	
export const TOGGLE_ACCOUNT_DROPDOWN = 'TOGGLE_ACCOUNT_DROPDOWN';	
export const TOGGLE_MOBILE_SETTINGS = 'TOGGLE_MOBILE_SETTINGS';	
export const TOGGLE_SPACE_MENU = 'TOGGLE_SPACE_MENU';	
export const SELECT_SPACE = 'SELECT_SPACE';	
export const SEND_ASSISTANCE_EMAIL = 'SEND_ASSISTANCE_EMAIL';	
export const INFORM_BALANCE = 'INFORM_BALANCE';	
export const SET_PRODUCT_AFTER_BALANCE = 'SET_PRODUCT_AFTER_BALANCE';	
export const CLOSE_CREDITS_POPUP = 'CLOSE_CREDITS_POPUP';	
export const TOGGLE_MODSY_BUY_INFO = 'TOGGLE_MODSY_BUY_INFO';	
export const TOGGLE_NOT_SUPPORTED_MODAL = 'TOGGLE_NOT_SUPPORTED_MODAL';	
export const SET_BROWSER_INFO = 'SET_BROWSER_INFO';	
export const CLEAR_STUDIO_SPACE = 'CLEAR_STUDIO_SPACE';	
export const NEW_STUDIO_SPACE_LOADED = 'NEW_STUDIO_SPACE_LOADED';	
export const STUDIO_DESIGN_RATING = 'STUDIO_DESIGN_RATING';	
export const STUDIO_SHOW_HIDE_DESIGN_FEEDBACK_MODEL = 'STUDIO_SHOW_HIDE_DESIGN_FEEDBACK_MODEL';	
export const STUDIO_SHOW_HIDE_DESIGN_FEEDBACK_THANKYOU_MODEL = 'STUDIO_SHOW_HIDE_DESIGN_FEEDBACK_THANKYOU_MODEL';	
export const STUDIO_SHOW_HIDE_HIGHLIGHT_PRODUCTS_MODAL = 'STUDIO_SHOW_HIDE_HIGHLIGHT_PRODUCTS_MODAL';	
export const STUDIO_SHOW_HIDE_HIGHLIGHT_ASSISTANCE_MODAL = 'STUDIO_SHOW_HIDE_HIGHLIGHT_ASSISTANCE_MODAL';	
export const STUDIO_USER_FEEDBACK_SUBMITTED = 'STUDIO_USER_FEEDBACK_SUBMITTED';	
// Onboarding	
export const UPDATE_ONBOARDING_INFO = 'UPDATE_ONBOARDING_INFO';	
export const TOGGLE_ONBOARDING = 'TOGGLE_ONBOARDING';	
export const LINK_INFO_TO_STYLEBOARD = 'LINK_INFO_TO_STYLEBOARD';	
export const SAVE_ONBOARDING_INFO_SUCCESS = 'SAVE_ONBOARDING_INFO_SUCCESS';	
export const SAVE_ONBOARDING_INFO_FAIL = 'SAVE_ONBOARDING_INFO_FAIL';	
export const CREATE_STYLEBOARD = 'CREATE_STYLEBOARD';	
export const CREATE_STYLEBOARD_FAIL = 'CREATE_STYLEBOARD_FAIL';	
export const GET_STYLEBOARD_AND_INFO_REQUEST =	
  'GET_STYLEBOARD_AND_INFO_REQUEST';	
export const GET_STYLEBOARD_AND_INFO_SUCCESS =	
  'GET_STYLEBOARD_AND_INFO_SUCCESS';	
export const GET_STYLEBOARD_AND_INFO_FAIL = 'GET_STYLEBOARD_AND_INFO_FAIL';	
export const UPDATE_WORKFLOW = 'UPDATE_WORKFLOW';	
// Product	
export const SELECT_PRODUCT = 'SELECT_PRODUCT';	
export const SELECT_ALT_PRODUCT = 'SELECT_ALT_PRODUCT';	
export const SELECT_ADD_PRODUCT = 'SELECT_ADD_PRODUCT';	
export const REMOVE_ADDED_PRODUCT = 'REMOVE_ADDED_PRODUCT';	
export const START_ADD_PRODUCT_FROM_REPLACE = 'START_ADD_PRODUCT_FROM_REPLACE';	
export const FETCH_PRODUCTS_FROM_REPLACE_SUCCESS =	
  'FETCH_PRODUCTS_FROM_REPLACE_SUCCESS';	
export const FETCH_PRODUCTS_FROM_REPLACE_FAIL =	
  'FETCH_PRODUCTS_FROM_REPLACE_FAIL';	
export const FETCH_PRODUCTS_FROM_REPLACE_REQUEST =	
  'FETCH_PRODUCTS_FROM_REPLACE_REQUEST';	
export const CLEAN_ADD_PRODUCTS = 'CLEAN_ADD_PRODUCTS';	
export const TOGGLE_PRODUCT_DETAILS = 'TOGGLE_PRODUCT_DETAILS';	
export const SET_ALT_PRODUCT_INDEX = 'SET_ALT_PRODUCT_INDEX';	
export const SET_ADD_PRODUCT_INDEX = 'SET_ADD_PRODUCT_INDEX';	
export const RECEIVE_ALTERNATIVES = 'RECEIVE_ALTERNATIVES';	
export const RECEIVE_SEARCH_ALTERNATIVES = 'RECEIVE_SEARCH_ALTERNATIVES';	
export const SELECT_PRODUCT_FILTER_OPTIONS = 'SELECT_PRODUCT_FILTER_OPTIONS';	
export const RECEIVE_MATERIALS = 'RECEIVE_MATERIALS';	
export const RECEIVE_COLORS = 'RECEIVE_COLORS';	
export const UPDATE_PRODUCT_QUANTITY = 'UPDATE_PRODUCT_QUANTITY';	
export const CLEAR_PRODUCT_FILTER = 'CLEAR_PRODUCT_FILTER';	
export const CLEAR_PRODUCT_FILTERS = 'CLEAR_PRODUCT_FILTERS';	
export const UPDATE_FILTERS_APPLIED_COUNT = 'UPDATE_FILTERS_APPLIED_COUNT';	
export const FILTER_SELECTED_PRODUCT = 'FILTER_SELECTED_PRODUCT';

export const OPEN_ACCOUNT_MODAL = 'OPEN_ACCOUNT_MODAL';	
export const CLOSE_ACCOUNT_MODAL = 'CLOSE_ACCOUNT_MODAL';
export const NAMECHANGE = 'REQUEST_NAME_CHANGE';	
export const NAMECHANGE_SUCCESS = 'NAMECHANGE_SUCCESS';	
export const NAMECHANGE_FAIL = 'NAMECHANGE_FAIL';	
export const PASSWORDCHANGE = 'REQUEST_PASSWORDCHANGE';
export const PASSWORDCHANGE_SUCCESS = 'PASSWORDCHANGE_SUCCESS';
export const PASSWORDCHANGE_FAIL = 'PASSWORDCHANGE_FAIL';
export const EMAILCHANGE = 'REQUEST_EMAILCHANGE';	
export const EMAILCHANGE_SUCCESS = 'EMAILCHANGE_SUCCESS';	
export const EMAILCHANGE_FAIL = 'EMAILCHANGE_FAIL';	
export const ACTIVATE = 'REQUEST_ACTIVATE';	
export const ACTIVATE_SUCCESS = 'ACTIVATE_SUCCESS';	
export const ACTIVATE_FAILURE = 'ACTIVATE_FAIL';	
export const ACTIVATE_CHANGEFORM = 'ACTIVATE_CHANGEFORM';
export const CHANGE_ACCOUNT_FORM = 'CHANGE_ACCOUNT_FORM';
export const IMAGE_UPLOAD = 'IMAGE_UPLOAD';	
export const IMAGE_UPLOAD_SUCCESS = 'IMAGE_UPLOAD_SUCCESS';	

 // Cart	
export const TOGGLE_EDIT_MODE = 'TOGGLE_EDIT_MODE';	
export const STRIPE_TOKEN = 'GET_STRIPE_TOKEN';	
export const STRIPE_TOKEN_FAIL = 'STRIPE_TOKEN_FAIL';	
export const STRIPE_TOKEN_SUCCESS = 'STRIPE_TOKEN_SUCCESS';	
export const ORDER_SUCCESS = 'MAKE_ORDER_SUCCESS';	
export const ORDER_FAIL = 'MAKE_ORDER_FAIL';	
export const LEAVE_ORDER_CONFIRM = 'LEAVE_ORDER_CONFIRM';	
export const REMOVE_ITEM = 'REMOVE_ITEM';	
export const ADD_ITEM = 'ADD_ITEM';	
export const CHANGE_ITEM_QTY = 'CHANGE_ITEM_QTY';	
export const UPDATE_CART = 'UPDATE_CART';	
export const UPDATE_CART_FAIL = 'UPDATE_CART_FAIL';	
export const UPDATE_CART_SUCCESS = 'UPDATE_CART_SUCCESS';	
export const UPDATE_CART_CREDITS = 'UPDATE_CART_CREDITS';	
export const UPDATE_CART_CREDITS_SUCCESS = 'UPDATE_CART_CREDITS_SUCCESS';	
export const UPDATE_CART_CREDITS_FAIL = 'UPDATE_CART_CREDITS_FAIL';	
export const SET_INFORMED_CREDITS = 'SET_INFORMED_CREDITS';	


 export const ART_CART = 'ART_CART';	
export const GET_CART = 'GET_CART';	
export const GET_CART_SUCCESS = 'GET_CART_SUCCESS';	
export const GET_CART_FAIL = 'GET_CART_FAIL';	
export const TOGGLE_ADDRESS_SAME = 'TOGGLE_ADDRESS_SAME';	
export const TOGGLE_CART_NOTIFICATION = 'TOGGLE_CART_NOTIFICATION';	
export const CHANGE_REMOVE_LIST = 'CHANGE_REMOVE_LIST';	
export const UPDATE_PAYMENT_TOTALS = 'UPDATE_PAYMENT_TOTALS';	
export const TOGGLE_CONFIRM_ORDER = 'TOGGLE_CONFIRM_ORDER';	
export const TOGGLE_CART_CONNECTION = 'TOGGLE_CART_CONNECTION';	
export const ADD_STYLEBOARD_INFO = 'ADD_STYLEBOARD_INFO';	

 // PaymentMeta	
export const PAYMENTMETA = 'PAYMENTMETA';	
export const PAYMENTMETA_SUCCESS = 'PAYMENTMETA_SUCCESS';	
export const PAYMENTMETA_FAIL = 'PAYMENTMETA_FAIL';	
// Billing	
export const CHANGE_FORM = 'CHANGE_FORM';	
export const TOGGLE_BILLING_INFO = 'TOGGLE_BILLING_INFO';	
export const SUBMIT_PAYMENT = 'SUBMIT_PAYMENT';	
// Upgrade	
export const OPEN_UPGRADE = 'OPEN_UPGRADE';	
export const CLOSE_UPGRADE = 'CLOSE_UPGRADE';	
// Space	
export const CHANGE_RENDER_INDEX = 'CHANGE_RENDER_INDEX';	
export const TOGGLE_PORTRAIT_ROTATE = 'TOGGLE_PORTRAIT_ROTATE';	
export const TOGGLE_LANDSCAPE_ROTATE = 'TOGGLE_LANDSCAPE_ROTATE';	
export const TOGGLE_PRODUCT_BAR = 'TOGGLE_PRODUCT_BAR';	
export const SET_PRODUCT_BAR_INDEX = 'SET_PRODUCT_BAR_INDEX';	
export const TOGGLE_DESIGN_BAR = 'TOGGLE_DESIGN_MENU';	
export const SELECT_DESIGN = 'SELECT_DESIGN';	
export const SET_DESIGN_BAR_INDEX = 'SET_DESIGN_BAR_INDEX';	
export const TOGGLE_PANORAMA_BAR = 'TOGGLE_PANORAMA_BAR';	
export const SELECT_PANORAMA = 'SELECT_PANORAMA';	
export const SET_PANORAMA_BAR_INDEX = 'SET_PANORAMA_BAR_INDEX';	
export const HAS_PANORAMAS = 'HAS_PANORAMAS';	
export const HAS_EDITOR = 'HAS_EDITOR';	
export const PANORAMA_MODAL_DISMISSED = 'PANORAMA_MODAL_DISMISSED';	
export const TOGGLE_PENDING_PRODUCTS = 'TOGGLE_PENDING_PRODUCTS';	
export const RENDERS_LOADED = 'RENDERS_LOADED';	
export const TRANSITION_RENDER = 'TRANSITION_RENDER';	
export const TRANSITION_DESIGN = 'TRANSITION_DESIGN';	
// Reset	// Reset
export const CHANGE_EMAIL_FORM = 'CHANGE_EMAIL_FORM';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const PASSWORD_RESET = 'PASSWORD_RESET';	
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';	
export const PASSWORD_RESET_FAIL = 'PASSWORD_RESET_FAIL';	
// Welcome	
export const WELCOME_INIT = 'WELCOME_INIT';	
export const WELCOME_INIT_SUCCESS = 'WELCOME_INIT_SUCCESS';	
export const WELCOME_INIT_FAILURE = 'WELCOME_INIT_FAILURE';	
export const WELCOME_DO_CONTINUE = 'WELCOME_DO_CONTINUE';	
export const WELCOME_DO_CONTINUE_SUCCESS = 'WELCOME_DO_CONTINUE_SUCCESS';	
export const WELCOME_DO_CONTINUE_FAILURE = 'WELCOME_DO_CONTINUE_FAILURE';	
// Replace	
export const RECEIVE_TOTAL_ALTERNATIVES = 'RECEIVE_TOTAL_ALTERNATIVES';	
export const TOGGLE_REPLACE = 'TOGGLE_REPLACE';	
export const SLIDE_PRODUCTS = 'SLIDE_PRODUCTS';	
export const SELECT_REPLACEMENT = 'SELECT_REPLACEMENT';	
export const UNDO_REMOVE_PRODUCT = 'UNDO_REMOVE_PRODUCT';	
export const REMOVE_REPLACEMENT = 'REMOVE_REPLACEMENT';	
export const RECEIVE_CATEGORIES = 'RECEIVE_CATEGORIES';	
export const REPLACE_PRODUCT = 'REPLACE_PRODUCT';	
export const REPLACE_ALT_PRODUCT = 'REPLACE_ALT_PRODUCT';	
export const TOGGLE_REVIEW_MODE = 'TOGGLE_REVIEW_MODE';	
export const CLOSE_TOUR = 'CLOSE_TOUR';	
export const REQUEST_REPLACEMENT = 'REQUEST_REPLACEMENT';	
export const REQUEST_REPLACEMENT_SUCCESS = 'REQUEST_REPLACEMENT_SUCCESS';	
export const REQUEST_REPLACEMENT_FAIL = 'REQUEST_REPLACEMENT_FAIL';	
export const UPDATE_ALT_PRODUCT_FILTER = 'UPDATE_ALT_PRODUCT_FILTER';	
export const UPDATE_ADD_PRODUCT_FILTER = 'UPDATE_ADD_PRODUCT_FILTER';	
export const SET_REPLACEMENT_NOTES = 'SET_REPLACEMENT_NOTES';	
// Dashboard	
export const SET_REMINDER = 'SET_REMINDER';	
export const SET_REMINDER_SUCCESS = 'SET_REMINDER_SUCCESS';	
export const SET_REMINDER_FAILURE = 'SET_REMINDER_FAILURE';	
export const CHANGE_TAB = 'CHANGE_TAB';	
export const CHANGE_PROGRESS = 'CHANGE_PROGRESS';	
export const TOGGLE_SELECT_STEP = 'TOGGLE_SELECT_STEP';	
export const CHANGE_PHOTO_PHASE = 'CHANGE_PHOTO_PHASE';	
export const CHANGE_INSTRUCTION_INDEX = 'CHANGE_INSTRUCTION_INDEX';	
export const UPLOAD_PHOTO = 'UPLOAD_PHOTO';	
export const REMOVE_UPLOAD = 'REMOVE_UPLOAD';	
export const REMOVE_PHOTO = 'REMOVE_PHOTO';	
export const CHANGE_MEASURE_FORM = 'CHANGE_MEASURE_FORM';	
export const SUBMIT_UPLOAD = 'SUBMIT_UPLOAD';	
export const SUBMIT_UPLOAD_FAIL = 'SUBMIT_UPLOAD_FAIL';	
export const SUBMIT_UPLOAD_SUCCESS = 'SUBMIT_UPLOAD_SUCCESS';	
export const SUBMIT_MEASUREMENT = 'SUBMIT_MEASUREMENT';	
export const SUBMIT_MEASUREMENT_FAIL = 'SUBMIT_MEASUREMENT_FAIL';	
export const SUBMIT_MEASUREMENT_SUCCESS = 'SUBMIT_MEASUREMENT_SUCCESS';	
export const TOGGLE_REMINDER_MODAL = 'TOGGLE_REMINDER_MODAL';	
export const TOGGLE_CONGRATS = 'TOGGLE_CONGRATS';	
export const SET_SPACE_FLAGS = 'SET_SPACE_FLAGS';	
export const UPLOAD_CUSTOM_PROP_PHOTO = 'UPLOAD_CUSTOM_PROP_PHOTO';	
export const SUBMIT_CUSTOM_PROP_SUCCESS = 'SUBMIT_CUSTOM_PROP_SUCCESS';	
export const SUBMIT_CUSTOM_PROP_FAIL = 'SUBMIT_CUSTOM_PROP_FAIL';	

 // Moodboard	
export const OPEN_ADD_PRODUCT = 'OPEN_ADD_PRODUCT';	
export const OPEN_REPLACE_PRODUCT = 'OPEN_REPLACE_PRODUCT';	
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';	
export const ADD_PRODUCT = 'ADD_PRODUCT';	
export const CHANGE_FILTER = 'CHANGE_FILTER';	
export const CLEAR_FILTER = 'CLEAR_FILTER';	
export const CLEAR_MOODBOARD = 'CLEAR_MOODBOARD';	
export const REPLACE_MOODBOARD_PRODUCT = 'REPLACE_MOODBOARD_PRODUCT';	
export const REMOVE_MOODBOARD_REPLACEMENT = 'REMOVE_MOODBOARD_REPLACEMENT';	
export const TOGGLE_MOODBOARD_CONFIRM = 'TOGGLE_MOODBOARD_CONFIRM';	
export const MOODBOARD_PRODUCTS_SUCCESS = 'MOODBOARD_PRODUCTS_SUCCESS';	
export const MOODBOARD_PRODUCTS_FAIL = 'MOODBOARD_PRODUCTS_FAIL';	
export const GET_SEARCH_PRODUCTS = 'GET_SEARCH_PRODUCTS';	
export const GET_SEARCH_PRODUCTS_SUCCESS = 'GET_SEARCH_PRODUCTS_SUCCESS';	
export const GET_SEARCH_PRODUCTS_FAIL = 'GET_SEARCH_PRODUCTS_FAIL';	
export const RESET_MOODBOARD = 'RESET_MOODBOARD';	
export const FETCH_MORE_PRODUCTS = 'FETCH_MORE_PRODUCTS';	
export const FETCH_MORE_PRODUCTS_SUCCESS = 'FETCH_MORE_PRODUCTS_SUCCESS';	
export const FETCH_MORE_PRODUCTS_FAIL = 'FETCH_MORE_PRODUCTS_FAIL';	
export const SUBMIT_MOODBOARD = 'SUBMIT_MOODBOARD';	
export const SUBMIT_MOODBOARD_SUCCESS = 'SUBMIT_MOODBOARD_SUCCESS';	
export const SUBMIT_MOODBOARD_FAIL = 'SUBMIT_MOODBOARD_FAIL';	
export const CLOSE_MOODBOARD_GUIDE = 'CLOSE_MOODBOARD_GUIDE';	
export const MAKE_NEW_SEARCH = 'MAKE_NEW_SEARCH';	
export const FILTER_SELECT_ALL = 'FILTER_SELECT_ALL';	
export const CHANGE_COMMENTS = 'CHANGE_COMMENTS';	
export const SAVE_MOODBOARD = 'SAVE_MOODBOARD';	
export const SAVE_MOODBOARD_SUCCESS = 'SAVE_MOODBOARD_SUCCESS';	
export const SAVE_MOODBOARD_FAIL = 'SAVE_MOODBOARD_FAIL';	
export const FETCH_MOODBOARD_SUCCESS = 'FETCH_MOODBOARD_SUCCESS';	


 // SignUp	// SignUp
export const OPEN_SIGNUP_MODAL = 'OPEN_SIGNUP_MODAL';	
export const CLOSE_SIGNUP_MODAL = 'CLOSE_SIGNUP_MODAL';	
export const SUBMIT_SIGNUP = 'SUBMIT_SIGNUP';
export const SUBMIT_SIGNUP_FAIL = 'SUBMIT_SIGNUP_FAIL';
export const SUBMIT_SIGNUP_SUCCESS = 'SUBMIT_SIGNUP_SUCCESS';

 // Stylequiz	
export const FETCH_STYLE_QUIZ_ROOMS = 'FETCH_STYLE_QUIZ_ROOMS';	
export const FETCH_STYLE_QUIZ_ROOMS_FAIL = 'FETCH_STYLE_QUIZ_ROOMS_FAIL';	
export const SELECT_ROOM = 'SELECT_ROOM';	
export const UN_SELECT_ROOM = 'UN_SELECT_ROOM';	
export const CLEAR_STYLEQUIZ_PRODUCTS = 'CLEAR_STYLEQUIZ_PRODUCTS';	
export const LIKE_PRODUCT = 'LIKE_PRODUCT';	
export const DISLIKE_PRODUCT = 'DISLIKE_PRODUCT';
export const SHUFFLED_PRODUCT = 'SHUFFLED_PRODUCT';
export const CHANGE_ROOM_INDEX = 'CHANGE_ROOM_INDEX';	
export const COMPLETE_STYLE_QUIZ = 'COMPLETE_STYLE_QUIZ';	
export const SUBMIT_STYLE_QUIZ_SUCCESS = 'SUBMIT_STYLE_QUIZ_SUCCESS';	
export const FETCH_STYLE_QUIZ_RESULTS = 'FETCH_STYLE_QUIZ_RESULTS';	
export const SET_SQ_SPACE_ID = 'SET_SQ_SPACE_ID';	
export const STYLE_QUIZ_RESULTS_ERROR = 'STYLE_QUIZ_RESULTS_ERROR ';	
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';	
export const CHANGE_POLL_CHOICE = 'CHANGE_POLL_CHOICE';	
export const SUBMIT_STYLE_QUIZ_POLL = 'SUBMIT_STYLE_QUIZ_POLL';	

 export const TOGGLE_CHECK = 'TOGGLE_CHECK';	
export const SET_DESIGN_PROJECT = 'SET_DESIGN_PROJECT';	

 // Workflow	
export const SELECT_WORKFLOW_ROOM = 'SELECT_WORKFLOW_ROOM';	
export const SELECT_BUDGET = 'SELECT_BUDGET';	
export const SELECT_NOT_SURE_OF_BUDGET = 'SELECT_NOT_SURE_OF_BUDGET';	
export const SELECT_NOT_SURE_OF_STYLE = 'SELECT_NOT_SURE_OF_STYLE';	
export const SELECT_OTHER_GOAL_OPTION = 'SELECT_OTHER_GOAL_OPTION';	
export const SELECT_OTHER_ROOM_OPTION = 'SELECT_OTHER_ROOM_OPTION';	
export const SET_OTHER_ROOM = 'SET_OTHER_ROOM';	
export const SET_OTHER_GOAL = 'SET_OTHER_GOAL';	
export const SET_OTHER_STYLES = 'SET_OTHER_STYLES';	
export const SET_WORKFLOW_PROJECT_SCOPE = 'SET_WORKFLOW_PROJECT_SCOPE';	
export const TRACK_QUESTION = 'TRACK_QUESTION';	
export const ADD_SELECTED_GOAL = 'ADD_SELECTED_GOAL';	
export const REMOVE_SELECTED_GOAL = 'REMOVE_SELECTED_GOAL';	
export const ADD_SELECTED_STYLE = 'ADD_SELECTED_STYLE';	
export const REMOVE_SELECTED_STYLE = 'REMOVE_SELECTED_STYLE';	
export const RESET_QUESTION_STATE = 'RESET_QUESTION_STATE';	

 // Retail partner	
export const SET_RETAIL_PARTNER = 'SET_RETAIL_PARTNER';
